import { faPagelines } from "@fortawesome/free-brands-svg-icons";
import {
  faCheck,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronLeft,
  faChevronRight,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import Fullscript from "../../assets/images/fullscript.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { ActionCreators as UndoActionCreators } from "redux-undo";
import {
  changeFormulaType,
  renderFormulaList,
} from "../../actions/formulaAction";
import {
  clearUnfinalizedPrescription,
  prescriptionPageTabShowItemList as setItem,
} from "../../actions/prescriptionAction";
import BreadCrumb from "../../components/Breadcrumb";
import CreatePatientTab from "../Patients/CreatePatientTab";
import MainPrescriptionPage from "./MainPrescriptionPage";
import PatientList from "./PatientList";
import ReviewPage from "./ReviewPage";
import FullscriptPage from "../Fullscript";
import { getUserDetail } from "../../utils/helper";
import {
  getPatientFormSettings,
  getPrescriptionFormSettings,
} from "../../actions/settingsActions";
import { getPractitionerCommission } from "../../actions/profileAction";
const CreatePrescription = () => {
  const [activeSection, setActiveSection] = useState(0);
  const isFullscriptConnected = getUserDetail()?.fullScriptConnected;
  const [showExistingPatient, setShowExistingPatient] = useState(0);
  const prescriptionPageTabShowItemList = useSelector(
    (state) => state.prescription.prescriptionPageTabShowItemList
  );
  const practitionerCommission = useSelector(
    (state) => state.profile.practitionerCommission
  );

  const [disease, setDisease] = useState("");
  const [pattern, setPattern] = useState("");
  const [formula, setFormula] = useState("");
  const [mod, setMod] = useState("");
  const [printHerbAmount, setPrintHerbAmount] = useState(1);
  const [totalPacket, setTotalPacket] = useState(1);
  const [multiplier, setMultiplier] = useState(1);
  const [formulaName, setFormulaName] = useState("");
  const [formulaNote, setFormulaNote] = useState("");
  const [commission, setCommission] = useState(0);
  const [prepMethod, setPrepMethod] = useState(0);
  const [patientName, setPatientName] = useState("");
  const [patientFirstName, setPatientFirstName] = useState("");
  const [patientLastName, setPatientLastName] = useState("");
  const [patientEmail, setPatientEmail] = useState("");
  const [patientPhone, setPatientPhone] = useState("");
  const [fullscriptId, setFullscriptId] = useState("");
  const [patientId, setPatientID] = useState(0);
  const [ppcId, setPpcId] = useState(0);
  const [packetsPerDay, setPacketsPerDay] = useState(1);
  const [days, setDays] = useState(0);
  const [scoops, setScoops] = useState(0);
  const [timePerDay, setTimePerDay] = useState(0);
  const [totalValue, setTotalValue] = useState(0);
  const [prepValue, setPrepValue] = useState(0);
  const [patientInstruction, setPatientInstruction] = useState("");
  const [pharmacyInstruction, setPharmacyInsytruction] = useState("");
  const [notesOnPrescription, setNotesOnPrescription] = useState("");
  const [rawGramPerDayBeforeConversion, setRawGramPerDayBeforeConversion] =
    useState(null);
  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    if (!prescriptionPageTabShowItemList.includes(1)) {
      setActiveSection(2);
    }
    return () => {
      dispatch(renderFormulaList(true));
      dispatch(setItem([1]));
      dispatch(clearUnfinalizedPrescription());
      dispatch(UndoActionCreators.clearHistory());
    };
  }, [dispatch]);

  const clearPrescriptionValue = () => {
    setDisease("");
    setPattern("");
    setFormula("");
    setMod("");
    setPrintHerbAmount(1);
    setCommission(0);
    setPrepMethod(null);
    setDays(0);
    setTimePerDay(0);
    setPacketsPerDay(1);
    setTotalPacket(1);
    setMultiplier(1);
    setScoops(0);
    setRawGramPerDayBeforeConversion(null);
    dispatch(changeFormulaType(true));
  };

  useEffect(() => {
    dispatch(getPatientFormSettings());
    dispatch(getPractitionerCommission());
    dispatch(getPrescriptionFormSettings());
  }, []);

  return (
    <div className="patients-page">
      <BreadCrumb
        pageName="
         Create Prescription"
      />
      <div className="row">
        <div className="col-sm-12">
          <h3 className="page-title">
            {prescriptionPageTabShowItemList.includes(1)
              ? "Create Prescription"
              : location?.state == "editFromCart"
              ? "Edit Prescription"
              : "Represcribe Prescription"}
          </h3>
          <div className="row mt-4">
            <div className="tab-wrapper">
              <div
                className={`tab ${activeSection === 0 ? "selected" : ""} ${
                  prescriptionPageTabShowItemList.includes(1)
                    ? "d-flex"
                    : "d-none"
                }`}
                onClick={() => setActiveSection(0)}
              >
                {" "}
                <FontAwesomeIcon icon={faUser} />
                <h2>Patient</h2>
              </div>
              {isFullscriptConnected ? (
                <div
                  className={`tab fullscript-tab ${
                    activeSection === 1 ? "selected" : ""
                  } ${
                    prescriptionPageTabShowItemList.includes(2)
                      ? "d-flex"
                      : "d-none"
                  }`}
                  onClick={() => setActiveSection(1)}
                >
                  <img height={34} src={Fullscript} alt="" />
                  <h2>Fullscript</h2>
                </div>
              ) : null}
              <div
                className={`tab ${activeSection === 2 ? "selected" : ""} ${
                  prescriptionPageTabShowItemList.includes(3)
                    ? "d-flex"
                    : "d-none"
                }`}
                onClick={() => setActiveSection(2)}
              >
                <FontAwesomeIcon icon={faPagelines} size="lg" />
                <h2>Formula</h2>
              </div>

              <div
                className={`tab ${activeSection === 3 ? "selected" : ""} ${
                  prescriptionPageTabShowItemList.includes(4)
                    ? "d-flex"
                    : "d-none"
                }`}
                onClick={() => setActiveSection(3)}
              >
                <FontAwesomeIcon icon={faCheck} size="lg" />
                <h2>Review</h2>
              </div>
            </div>
            <div className="col-sm-12">
              <div
                className={`detail-wrapper ${
                  activeSection === 2 ? "review" : ""
                }`}
              >
                <div
                  className={`tab-detail-item ${
                    activeSection === 0 ? "tab-active" : ""
                  }`}
                >
                  {" "}
                  <p className="page-desc">
                    Select your patient to begin creating the prescription.
                    Choose from existing patients, create a new patient or
                    invite patient.
                  </p>
                  <div className="d-flex">
                    <div className="radio-item">
                      <label
                        className="container"
                        onClick={() => setShowExistingPatient(0)}
                      >
                        Existing Patient
                        <input
                          type="radio"
                          checked={showExistingPatient == 0}
                          name="existing"
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    <div className="radio-item">
                      <label
                        className="container"
                        onClick={() => setShowExistingPatient(1)}
                      >
                        New Patient
                        <input
                          type="radio"
                          name="new"
                          checked={showExistingPatient == 1}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    <div className="radio-item">
                      <label
                        className="container"
                        onClick={() => setShowExistingPatient(2)}
                      >
                        My Clinic
                        <input
                          type="radio"
                          name="new"
                          checked={showExistingPatient == 2}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </div>
                  {showExistingPatient == 0 && (
                    <PatientList
                      forMyClinic={false}
                      setPpcId={setPpcId}
                      setPatientID={setPatientID}
                      setPatientName={setPatientName}
                      setPatientFirstName={setPatientFirstName}
                      setPatientLastName={setPatientLastName}
                      setPatientEmail={setPatientEmail}
                      setPatientPhone={setPatientPhone}
                      setFullscriptId={setFullscriptId}
                      setActiveSection={setActiveSection}
                      clearPrescriptionValue={clearPrescriptionValue}
                      setPatientInstruction={setPatientInstruction}
                      setPharmacyInsytruction={setPharmacyInsytruction}
                      setNotesOnPrescription={setNotesOnPrescription}
                    />
                  )}
                  {showExistingPatient == 1 && (
                    <CreatePatientTab
                      setPpcId={setPpcId}
                      setPatientID={setPatientID}
                      setPatientName={setPatientName}
                      setPatientFirstName={setPatientFirstName}
                      setPatientLastName={setPatientLastName}
                      setPatientEmail={setPatientEmail}
                      setPatientPhone={setPatientPhone}
                      setFullscriptId={setFullscriptId}
                      clearPrescriptionValue={clearPrescriptionValue}
                      setActiveSection={setActiveSection}
                      setItem={setItem}
                    />
                  )}
                  {showExistingPatient == 2 && (
                    <PatientList
                      forMyClinic={true}
                      setPpcId={setPpcId}
                      setPatientID={setPatientID}
                      setPatientName={setPatientName}
                      setPatientFirstName={setPatientFirstName}
                      setPatientLastName={setPatientLastName}
                      setPatientEmail={setPatientEmail}
                      setPatientPhone={setPatientPhone}
                      setFullscriptId={setFullscriptId}
                      setActiveSection={setActiveSection}
                      clearPrescriptionValue={clearPrescriptionValue}
                      setPatientInstruction={setPatientInstruction}
                      setPharmacyInsytruction={setPharmacyInsytruction}
                      setNotesOnPrescription={setNotesOnPrescription}
                    />
                  )}
                </div>
                {prescriptionPageTabShowItemList.includes(3) && (
                  <div
                    className={`tab-detail-item ${
                      activeSection === 2 ? "tab-active" : ""
                    }`}
                  >
                    <MainPrescriptionPage
                      multiplier={multiplier}
                      setMultiplier={setMultiplier}
                      setTotalPacket={setTotalPacket}
                      totalPacket={totalPacket}
                      disease={disease}
                      setDisease={setDisease}
                      pattern={pattern}
                      setPattern={setPattern}
                      formula={formula}
                      setFormula={setFormula}
                      mod={mod}
                      setMod={setMod}
                      printHerbAmount={printHerbAmount}
                      setPrintHerbAmount={setPrintHerbAmount}
                      formulaName={formulaName}
                      setFormulaName={setFormulaName}
                      formulaNote={formulaNote}
                      setFormulaNote={setFormulaNote}
                      commission={commission}
                      setCommission={setCommission}
                      practitionerCommission={practitionerCommission}
                      prepMethod={prepMethod}
                      setPrepMethod={setPrepMethod}
                      patientName={patientName}
                      setPatientName={setPatientName}
                      setPatientFirstName={setPatientFirstName}
                      setPatientLastName={setPatientLastName}
                      setPatientEmail={setPatientEmail}
                      setPatientPhone={setPatientPhone}
                      setFullscriptId={setFullscriptId}
                      patientId={patientId}
                      setPatientID={setPatientID}
                      setPpcId={setPpcId}
                      ppcId={ppcId}
                      packetsPerDay={packetsPerDay}
                      setPacketsPerDay={setPacketsPerDay}
                      days={days}
                      setDays={setDays}
                      scoops={scoops}
                      setScoops={setScoops}
                      timePerDay={timePerDay}
                      setTimePerDay={setTimePerDay}
                      totalValue={totalValue}
                      setTotalValue={setTotalValue}
                      prepValue={prepValue}
                      setPrepValue={setPrepValue}
                      setActiveSection={setActiveSection}
                      patientInstruction={patientInstruction}
                      setPatientInstruction={setPatientInstruction}
                      pharmacyInstruction={pharmacyInstruction}
                      setPharmacyInsytruction={setPharmacyInsytruction}
                      notesOnPrescription={notesOnPrescription}
                      setNotesOnPrescription={setNotesOnPrescription}
                      isFullscriptConnected={isFullscriptConnected}
                      fullscriptId={fullscriptId}
                      setRawGramPerDayBeforeConversion={
                        setRawGramPerDayBeforeConversion
                      }
                      rawGramPerDayBeforeConversion={
                        rawGramPerDayBeforeConversion
                      }
                    />
                  </div>
                )}
                {isFullscriptConnected ? (
                  <>
                    {prescriptionPageTabShowItemList.includes(2) && (
                      <div
                        className={`tab-detail-item ${
                          activeSection === 1 ? "tab-active" : ""
                        }`}
                      >
                        <FullscriptPage
                          patientFirstName={patientFirstName}
                          patientLastName={patientLastName}
                          patientEmail={patientEmail}
                          patientPhone={patientPhone}
                          fullscriptId={fullscriptId}
                          setFullscriptId={setFullscriptId}
                          ppcId={ppcId}
                        />
                        <div className="d-flex justify-content-between mt-2 ml-5 mr-5">
                          <button
                            className="white-btn"
                            onClick={() => setActiveSection(0)}
                          >
                            <FontAwesomeIcon size="xs" icon={faChevronLeft} />{" "}
                            back
                          </button>
                          <button
                            className="white-btn orange"
                            onClick={() => {
                              if (prescriptionPageTabShowItemList.includes(1)) {
                                dispatch(setItem([1, 2, 3]));
                              } else {
                                dispatch(setItem([2, 3]));
                              }
                              setActiveSection(2);
                            }}
                          >
                            {" "}
                            Formula{" "}
                            <FontAwesomeIcon size="xs" icon={faChevronRight} />
                          </button>
                        </div>
                      </div>
                    )}
                  </>
                ) : null}
                {prescriptionPageTabShowItemList.includes(4) && (
                  <div
                    className={`tab-detail-item ${
                      activeSection === 3 ? "tab-active" : ""
                    }`}
                  >
                    <ReviewPage
                      multiplier={multiplier}
                      setMultiplier={setMultiplier}
                      totalPacket={totalPacket}
                      disease={disease}
                      pattern={pattern}
                      formula={formula}
                      mod={mod}
                      printHerbAmount={printHerbAmount}
                      formulaName={formulaName}
                      formulaNote={formulaNote}
                      commission={commission}
                      prepMethod={prepMethod}
                      patientName={patientName}
                      patientEmail={patientEmail}
                      setPatientEmail={setPatientEmail}
                      patientId={patientId}
                      ppcId={ppcId}
                      packetsPerDay={packetsPerDay}
                      days={days}
                      scoops={scoops}
                      timePerDay={timePerDay}
                      totalValue={totalValue}
                      prepValue={prepValue}
                      setActiveSection={setActiveSection}
                      patientInstruction={patientInstruction}
                      pharmacyInstruction={pharmacyInstruction}
                      notesOnPrescription={notesOnPrescription}
                      prescriptionPageTabShowItemList={
                        prescriptionPageTabShowItemList
                      }
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePrescription;
